export const RESEND_CODE = "RESEND_CODE";

export function resendCode() {
    return { type: RESEND_CODE };
}
